import React from 'react';
import { ArrowRight, Laptop } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { usePlatform } from './PlatformContext';
import './streaks.css';

export const GuestProfileCard = ({ profile, prefix = 'daily-guest', showHistory = true }) => {
  const { openAuth, navigate } = usePlatform();
  if (!profile) return null;
  return <Card className="ps-identity daily-streak-card guest-profile-card" data-testid={`${prefix}-identity-card`}>
    <div className="daily-streak-card-title"><Laptop size={18} aria-hidden="true"/><strong data-testid={`${prefix}-identity-name`}>You’re playing as {profile.alias}</strong></div>
    <p data-testid={`${prefix}-device-note`}>Your scores and streak will stay on this browser/device.</p>
    <p data-testid={`${prefix}-save-note`}>Create a CubitPlay account to keep your name, history and streak across devices.</p>
    <div className="flex flex-wrap items-center gap-2 mt-3">
      <Button variant="outline" className="platform-secondary" data-testid={`${prefix}-save-profile-button`} onClick={() => openAuth('invite')}>SAVE MY PROFILE<ArrowRight size={15}/></Button>
      {showHistory && <Button variant="ghost" data-testid={`${prefix}-history-button`} onClick={() => navigate('/account')}>View my history</Button>}
    </div>
  </Card>;
};
